// extracted by mini-css-extract-plugin
export default {"errorWrapper":"Error_errorWrapper__KV7ER"};